<script setup>
    import {computed} from "vue";
    import SubNav from "../../components/global/SubNav.vue";
    import {useRoute} from "vue-router";
    import {useAuthStore} from "../../store/auth.js";

    const route = useRoute()
    const authStore = useAuthStore()

    const links = computed(() => [
        { to: '/chats/open', label: 'Open'},
        { to: '/chats/complete', label: 'Completed'},
        ...(authStore.canViewChatStats ? [{ to: '/chats/stats', label: 'Stats'}] : []),
        ...(authStore.canBulkSend ? [{ to: '/chats/bulk-sends', label: 'Bulk Sends'}] : []),
    ]);

</script>

<template>
    <sub-nav :links="links" v-if="route.name !== 'tickets-single'" />
    <router-view v-slot="{ Component }">
        <keep-alive :include="['ChatsOpen', 'ChatsComplete', 'BulkSendsView']">
            <component :is="Component" />
        </keep-alive>
    </router-view>
</template>
